module.exports = __webpack_public_path__ + "static/media/img_money_packs.dc2fbd8a.png";